const stripFirstLabel = (host: string): string => host.split(".").slice(1).join(".");

export const getTrustedBaseDomain = (): string => {
  const source =
    window.PF.config.ms_teams_default_domain ||
    window.PF.config.ms_teams_domain ||
    window.PF.config.development_domain ||
    window.location.hostname;

  return stripFirstLabel(source);
};

export const isTrustedAccountDomain = (host: string | null | undefined): host is string => {
  if (!host) {
    return false;
  }

  const base = getTrustedBaseDomain();
  if (!base) {
    return false;
  }

  return host === base || host.endsWith(`.${base}`);
};

export const safeAccountDomain = (candidate: string | null | undefined, fallback: string): string =>
  isTrustedAccountDomain(candidate) ? candidate : fallback;
